// 药店拜访-->巡店计划-->中英文
export const visitLocale = {
    'zhCN': {
        drugstore: {
            selectDrugstore: '选择药店',
            drugstoreName: '药店名称',
            addedSuccess: '添加成功',
            uploadFormatError: '文件类型错误，仅支持xlsx类型文件。',
            batchDelete: '批量删除',
            selectionDeleteIsRequired: '请选择删除的数据'
        },
        visitPlan: {
            salesCycle: '计划周期',
            employeeName: '药店负责人',
            region: '销售大区',
            drugStoreType: '药店类型',
            drugStoreLevel: '药店分级',
            generatePlan: '生成检查计划',
            publishPlan: '发布计划',
            batchPublish: '批量发布',
            remark: '备注',
            employeePhone: '负责人电话',
            email: '邮箱',
            planReleaseStatus: '计划发布状态',
            numberOfPlan: '计划检查次数',
            numberOfCompleted: '已完成次数',
            numberOfRemain: '剩余次数',
            planStatus: '计划状态',
            generatePlanSuccess: '生成成功',
            salesCycleRequired: '请选择计划周期',
            publishPlanSuccess: '发布成功',
            disableSuccess: '停用成功',
            enableSuccess: '启用成功',
            selectionIsRequired: '请选择需要发布的计划',
            editVisitPlan: '编辑',
            receiver: '收货方名称',
            selectReceiver: '选择收货方',
            receiverFormerName: '收货方曾用名',
            validReceiverRequired: '请选择收货方',
            validDrugStoreTypeRequired: '请选择药店类型',
            validDrugStoreLevelRequired: '请选择药店级别',
            validProductRequired: '请选择产品',
            validNumberOfPlanRequired: '请输入巡店次数',
            validEmployeeRequired: '请选择负责人',
            validSalesAreaRequired: '请选择销售大区',
            validRemarkLength: '备注内容过长',
            drugstoreName: '药店名称'

        },
        visitResult: {
            visitDate: '检查日期',
            isProvidePrescription: '是否提供处方',
            isMeetStorageRequirements: '是否符合存储要求',
            isBiologics: '是否包含生物制品',
            isColdchain: '是否经销冷链产品',
            inventoryQuantity: '库存数量',
            quantityInTransit: '在途数量',
            basicInfo: '基本信息：',
            detail: '查看详情',
            provinceAndCity: '省份/城市',
            productName: '产品名称',
            numberOfRemain: '剩余检查次数',
            signIn: '到店签到：',
            date: '日期',
            detailedDescription: '详细说明',
            detailedDescriptionTitle: '详细说明：'
        },
        drugstoreBUManagement: {
            receiver: '收货方名称',
            PHCode: 'PHCode',
            MDMCode: 'MDMCode',
            productName: '产品名称',
            BU: 'BU',
            drugstorePrincipal: '药店负责人',
            region: '销售大区',
            drugstoreType: '药店类型',
            drugstoreLevel: '药店分级',
            MUID: 'MUID',
            principalPhone: '药店负责人电话',
            principalMail: '邮箱',
            numberOfVisit: '计划检查次数',
            remark: '备注',
            whetherDelDrugstoreBU: '是否删除该数据',
            editDrugstoreBU: '编辑BU与药店基础数据',
            viewDrugstoreBU: '查看BU与药店基础数据',
            addDrugstoreBU: '新增BU与药店基础数据'
        },
        shippingModeManagement: {
            Date: '生效年月',
            productShortName: '产品简称',
            materialGroup: '分型名称',
            shippingMode: '发货模式',
            startDate: '生效起始时间',
            endDate: '生效结束时间',
        }

    },
    'enUS': {
        drugstore: {
            selectDrugstore: 'Select Drugstore',
            drugstoreName: 'Drugstore Name',
            addedSuccess: 'Added Success',
            uploadFormatError: 'Upload file format incorrect, only support xlsx format file',
            batchDelete: 'Batch Delete',
            selectionDeleteIsRequired: 'Please select the data to be deleted'
        },
        visitPlan: {
            salesCycle: 'Sales Cycle',
            employeeName: 'Principal',
            region: 'Region',
            drugStoreType: 'Drug Store Type',
            drugStoreLevel: 'Drug Store Level',
            generatePlan: 'Generate Plan',
            publishPlan: 'Publish Plan',
            batchPublish: 'Batch Publish',
            remark: 'Remarks',
            employeePhone: 'Employee Phone',
            email: 'Email',
            planReleaseStatus: 'Plan Release Status',
            numberOfPlan: 'Number Of Plan',
            numberOfCompleted: 'Number Of Completed',
            numberOfRemain: 'Number Of Remain',
            planStatus: 'Plan Status',
            generatePlanSuccess: 'Visit plan has been generated successfully',
            salesCycleRequired: 'Sales flow Cycle is required',
            publishPlanSuccess: 'Visit plan has been published successfully',
            disableSuccess: 'Visit plan has been disabled successfully',
            enableSuccess: 'Visit plan has been enabled successfully',
            selectionIsRequired: 'Please select the plan you want to publish',
            editVisitPlan: 'Edit',
            receiver: 'Receiver',
            selectReceiver: 'Select Receiver',
            receiverFormerName: 'Receiver Former Name',
            validReceiverRequired: 'Receiver is required',
            validDrugStoreTypeRequired: 'Drug store type is required',
            validDrugStoreLevelRequired: 'Drug store level is required',
            validProductRequired: 'Product is required',
            validNumberOfPlanRequired: 'Number of plan is required',
            validEmployeeRequired: 'Employee is required',
            validSalesAreaRequired: 'Sales area is required',
            validRemarkLength: 'Remark is too long',
            drugstoreName: 'Drugstore Name'
        },
        visitResult: {
            visitDate: 'Visit Date',
            isProvidePrescription: 'Prescription Status',
            isMeetStorageRequirements: 'Storage Status',
            isBiologics: 'Biologics Status',
            isColdchain: 'Cold Chain Status',
            inventoryQuantity: 'Inventory Quantity',
            quantityInTransit: 'Quantity In Transit',
            basicInfo: 'Basic Info:',
            detail: 'Detail',
            provinceAndCity: 'Province/City',
            productName: 'Product Name',
            numberOfRemain: 'Number Of Remain',
            signIn: 'Sign In:',
            date: 'Date',
            detailedDescription: 'Detailed Description',
            detailedDescriptionTitle: 'Detailed Description：'
        },
        drugstoreBUManagement: {
            receiver: 'Receiver',
            PHCode: 'PHCode',
            MDMCode: 'MDMCode',
            productName: 'Product Name',
            BU: 'BU',
            drugstorePrincipal: 'Principal',
            region: 'Region',
            drugstoreType: 'Drugstore Type',
            drugstoreLevel: 'Drugstore Level',
            MUID: 'MUID',
            principalPhone: 'Principal Phone',
            principalMail: 'Principal Mail',
            numberOfVisit: 'Number Of Visit',
            remark: 'Remark',
            whetherDelDrugstoreBU: 'Whether remove this data',
            editDrugstoreBU: 'Edit',
            viewDrugstoreBU: 'Details',
            addDrugstoreBU: 'Add'
        },
        shippingModeManagement: {
            Date: 'Date',
            productShortName: 'Product Referred',
            materialGroup: 'Material Group',
            shippingMode: 'Shipping Mode',
            startDate: 'Start Date',
            endDate: 'End Date',
        }
    }
}
export default visitLocale



// WEBPACK FOOTER //
// ./src/locale/modules/visitLocale.js